// extracted by mini-css-extract-plugin
export default {"collections":"collections___TEjzZ","collection":"collection___sb6Vo","card":"card___Rum9d","cover":"cover___C6EX2"};